import React from "react";

import "./TabContent.scss";
import TabSection from "./TabSection/TabSection";

const TabContent = (props) => {

  const [isFieldAcive, setIsFieldActive] = React.useState(false);
  return props.sections.map((section, index) => {
    return (
      <TabSection 
        key={section.sectionId}
        section={section}
        index={index}
        isFieldAcive={isFieldAcive}
        setIsFieldActive={setIsFieldActive}
        showAddFieldButton={props.tabName !== 'overview'}
        {...props}
      />
    );
  });
};

export default TabContent;
